module.exports = __webpack_public_path__ + "static/media/ost_5.83621a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_5.png
// module id = 1045
// module chunks = 0